module.exports = __webpack_public_path__ + "media/images/lb/722-4ccefc1395c06418a637dc5ccb0a471d.svg";